import React, { useEffect } from 'react'
import * as Sentry from "@sentry/react";

export default function GlobalImports({ appProps }) {

  useEffect( ()=> {
    if (appProps?.crashReportsEnabled) {
      Sentry.init({
        dsn: appProps.sentryDsn,
        integrations: [],
      });
    }
  },[])

  return (
    <></>
  )
}